<script module>
  import { resolve } from '$app/paths'
  import img1 from './starting-a-session-1.webp'

  export const meta = {
    title: 'Starting a session',
    teaser:
      'Learn how to start a session with options for immediate or scheduled starts,\nchoose your audience among public, friends, or organization members, and\ndiscover existing sessions to join for added motivation.',
    sort: -1,
  }
</script>

<p>
  When you <a href={resolve('/session/create')}>start a session</a>, you're
  given the flexibility to kick off the session either instantly or at a later
  time. This convenient feature allows your friends and colleagues to hop into
  your session smoothly and gives you a moment to wrap up any pending tasks.
</p>
<h2>Choose Your Audience</h2>
<p>
  Selecting your session's start time is just the beginning. You can also
  specify who gets an invite and a notification to join.
</p>
<img src={img1} alt="Screenshot of audience selection" />
<ul>
  <li>
    <strong>Public</strong>: Choosing a public session opens the door for other
    Pausly users to join in on the fun. Rest assured, your audio chat remains
    private. However, they can send you supportive emojis, creating a community
    of motivation.
  </li>
  <li>
    <strong>Friends</strong>: This option sends an invite to all Pausly users
    you've connected with as friends, provided they have added you as well.
    (Note that this option is only available after you have added your first
    friend)
  </li>
  <li>
    For those in a Pausly Organization, you'll also see an option here to
    include your organization or specific teams.
  </li>
</ul>
<p>
  Prefer a session all to yourself? Simply deselect all options, making your
  session invisible to others.
</p>
<blockquote>
  <p>
    Remember, you can <em>always</em> share your session's link with anyone, and they'll
    be able to join, no matter the notification settings you've chosen.
  </p>
</blockquote>
<h2>Discover Existing Sessions</h2>
<p>
  Right below where you create your session, there's a list showcasing public
  sessions and sessions created by your friends. If you find one that matches
  your schedule, feel free to join in. It's often more motivating to take breaks
  with others!
</p>
